import { FC } from 'react'
import { Banner } from '@/root/ui/tuuleliinid'
import { useGetTranslations } from '@/root/shared-hooks'

export const EmailConfirmation: FC = () => {
  const { getTranslation } = useGetTranslations()

  return (
    <div className="flex w-full flex-col">
      <h3 className="text-primary-base mb-4 text-base font-bold">
        {getTranslation('authCheckMailboxTitle')}
      </h3>
      <Banner variant="info" align="left" body={getTranslation('authActivationLinkSent', { strong: (chunks) => `<strong>${chunks}</strong>` })} bodyClassName="text-sm leading-relaxed" />
    </div>
  )
}
